import {ColonistMembershipProduct} from '../../../../shared/store/ColonistMembershipProduct'
import {DiscordAnnualMembershipPrices} from '../../../../shared/store/StoreConstants'
import {setElementInnerText} from '../ui_utils/DomUtils'
import {UIStoreMembershipTabsController} from './UIStoreMembershipTabsController'
import {UIStoreState} from './UIStoreState'
import {ColonistMembershipType} from '@colonist/types'

export class UIDStoreMembershipTabsController extends UIStoreMembershipTabsController {
    constructor(storeState: UIStoreState) {
        super(storeState)
        this.setAnnualTabText()
    }

    private setAnnualTabText() {
        const nonDiscountedAnnualPrice = ColonistMembershipProduct.getMembershipProduct(ColonistMembershipType.PremiumMonthly).price * 12
        const discount = Math.round((1 - DiscordAnnualMembershipPrices.PREMIUM / nonDiscountedAnnualPrice) * 100)

        setElementInnerText(this.annualTab, {key: 'strings:storePage.membership.frequency.annual', options: {context: 'store', discount: discount}})
    }
}
